import { useCompoundBody } from "@react-three/cannon";
import { useRef } from "react";
import { Group } from "three";
import { Box, Cylinder, ObjectProps, useDragConstraint } from "../utils";

export default ({position, rotation}: ObjectProps) => {
  const [ref] = useCompoundBody(() => ({
    mass: 30,
    position: position ?? [0, 0, 0],
    rotation: rotation ?? [0, 0, 0],
    shapes: [
      { type: 'Box',      position: [0,    0, 0], args: [ 3.5, 13.5, 0.2],                                      mass: 20 },
      { type: 'Cylinder', position: [0, 6.75, 0], args: [1.75, 1.75, 0.2, 32], rotation: [  Math.PI / 2, 0, 0], mass: 5 },

      { type: 'Box', position: [ 1.7,  -1.5, 1.5], args: [0.1,   10, 0.1],     rotation: [-Math.PI / 12, 0, 0], mass: 2 },
      { type: 'Box', position: [-1.7,  -1.5, 1.5], args: [0.1,   10, 0.1],     rotation: [-Math.PI / 12, 0, 0], mass: 2 },
      { type: 'Box', position: [   0, -6.35, 2.8], args: [3.5,  0.1, 0.1],     rotation: [-Math.PI / 12, 0, 0], mass: 1 },
    ], 
    type: 'Dynamic',
  }), useRef<Group>(null));
  const bind = {}; // useDragConstraint(ref);
  return (
    <group ref={ref} {...bind}>
      <Box position={[0, 0, 0]} args={[3.5, 13.5, 0.2]} />
      <Cylinder position={[0, 6.75, 0]} rotation={[Math.PI / 2, 0, 0]} args={[1.75, 1.75, 0.2, 32]} />

      <Box position={[ 1.6999, -1.5,  1.35]} args={[0.1,  10,  0.1]} rotation={[-Math.PI / 12, 0, 0]} color="#2a2a2a" />
      <Box position={[-1.6999, -1.5,  1.35]} args={[0.1,  10,  0.1]} rotation={[-Math.PI / 12, 0, 0]} color="#2a2a2a" />
      <Box position={[   0, -6.35, 2.65]} args={[3.5, 0.1, 0.1]} rotation={[-Math.PI / 12, 0, 0]} color="#2a2a2a" />
    </group>
  );
};
